import { Box, InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";

interface ParticipantsSearchFieldProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

/**
 * Pole wyszukiwania zawodników
 * Zgodny z zasadą pojedynczej odpowiedzialności - tylko pole wyszukiwania
 */
export default function ParticipantsSearchField({
  searchTerm,
  onSearchChange,
}: ParticipantsSearchFieldProps) {
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        borderBottom: "1px solid #ddd",
        px: { xs: 2, sm: 3 },
        py: 2,
      }}
    >
      <TextField
        fullWidth
        size="small"
        placeholder="Wyszukaj po imieniu, nazwisku lub dacie urodzenia..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search sx={{ color: "#6366f1", fontSize: 20 }} />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#ddd",
            },
            "&:hover fieldset": {
              borderColor: "#6366f1",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#6366f1",
            },
          },
        }}
      />
    </Box>
  );
}
